import React, { useState } from "react";
// import "./CompetitionTable.css";

function CompetitionTable({ competitions, onCreate, onUpdate }) {
  const [searchTerm, setSearchTerm] = useState("");
  const [filter, setFilter] = useState("all");

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleFilter = (e) => {
    setFilter(e.target.value);
  };

  const filteredCompetitions = competitions.filter((competition) => {
    if (filter === "all") {
      return true;
    } else if (filter === "past") {
      return new Date(competition.date) < new Date();
    } else if (filter === "future") {
      return new Date(competition.date) >= new Date();
    }
  });

  const filteredAndSearchedCompetitions = filteredCompetitions.filter((competition) => {
    const nameMatch = competition.name.toLowerCase().includes(searchTerm.toLowerCase());
    const dateMatch = competition.date.includes(searchTerm);
    return nameMatch || dateMatch;
  });

  return (
    <div className="competition-table">
      <div className="competition-table-header">
        <h2>Competitions</h2>
        <button onClick={onCreate}>Create Competition</button>
      </div>
      <div className="competition-table-controls">
        <div className="search-box">
          <input
            type="text"
            placeholder="Search by name or date"
            value={searchTerm}
            onChange={handleSearch}
          />
        </div>
        <div className="filter-box">
          <select value={filter} onChange={handleFilter}>
            <option value="all">All Competitions</option>
            <option value="past">Past Competitions</option>
            <option value="future">Future Competitions</option>
          </select>
        </div>
      </div>
      <table>
        <thead>
          <tr>
            <th>Name</th>
            <th>Date</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {filteredAndSearchedCompetitions.map((competition) => (
            <tr key={competition.id}>
              <td>{competition.name}</td>
              <td>{competition.date}</td>
              <td>
                <button onClick={() => onUpdate(competition)}>Update</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default CompetitionTable;